var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-page" },
    [
      _vm._m(0),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关键词" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.openCreate } }, [
                    _vm._v("新任务"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.tableData.data, size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "task.taskNo",
                  label: "编号",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "主题", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.topicText(row.task)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "task.scene", label: "场景", width: "110" },
              }),
              _c("el-table-column", {
                attrs: { prop: "task.status", label: "状态", width: "100" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "task.intentionScore",
                  label: "意向分",
                  width: "90",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "280" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return _vm._l(row.actions, function (action) {
                        return _c(
                          "el-button",
                          {
                            key: action,
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.runAction(row, action)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.actionText(action)))]
                        )
                      })
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, prev, pager, next",
                  total: _vm.tableData.total,
                },
                on: {
                  "current-change": function (page) {
                    _vm.searchForm.page = page
                    _vm.loadCurrent()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("AI TOUCH")]),
        _c("h2", [_vm._v("AI种草")]),
        _c("p", [_vm._v("生成种草文案后推送，再追踪送达打开与意向分。")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }